import { render, staticRenderFns } from "./detailCpn.vue?vue&type=template&id=7f22e626&scoped=true&"
import script from "./detailCpn.vue?vue&type=script&lang=js&"
export * from "./detailCpn.vue?vue&type=script&lang=js&"
import style0 from "./detailCpn.vue?vue&type=style&index=0&id=7f22e626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f22e626",
  null
  
)

export default component.exports